// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-eb4e1762] .el-table__body-wrapper {\n  height: auto !important;\n}\n.base-table-container[data-v-eb4e1762] {\n  width: 100%;\n}\n.base-table-container .pagination-container[data-v-eb4e1762] {\n  margin-top: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}", ""]);
// Exports
module.exports = exports;
